import { GoogleAnalyticsService } from './google-analytics-service'

export const analytics = new GoogleAnalyticsService()
